export default __webpack_public_path__ + "static/media/launch.60c5ee1f.png";